import { Component, OnInit } from '@angular/core';
import { Event, Router, NavigationStart, NavigationEnd, ParamMap } from '@angular/router';
import { BehaviorModelChangeService } from 'src/app/service/behavior-model-change.service.service';

@Component({
  selector: 'app-account-layout',
  templateUrl: './account-layout.component.html',
  styleUrls: ['./account-layout.component.css']
})
export class AccountLayoutComponent implements OnInit {
  public ShowLoadingIndicator=true;
  applicantType="";


  constructor(private router: Router,
    private behaviorModelChangeService:BehaviorModelChangeService) {

     
    
  
  }

  







  ngOnInit() {
    // this.applicantType="UNDERGRADUATE LOGIN";

    
   


    


  }

}
